import { getFeatureToggleClient } from 'misc/featureToggles'

export function isNewLegendSelectionScreenToggleEnabled() {
  return getFeatureToggleClient().variation(
    'CustomerPortal.NewLegendSelectionScreenToggle',
    false
  )
}
